import { MEDIA_QUERIES } from '@kijiji/ui'
import styled from 'styled-components'

import { VipSectionContainer } from '@/components/vip/shared/VipSectionContainer'

export const VipSectionContainerMobile = styled(VipSectionContainer)(
  ({ theme }) => `
  ${MEDIA_QUERIES(theme).medium} {
    display: none;
  }
`
)
